import { logEvent } from 'services/analytics/segment/segment';

interface ChangeAddressAnalyticsProps {
  isCheckedHomeAndMailingAddress: boolean | undefined;
  isHomeScreenType: boolean;
  pathname: string;
}

export const createChangeAddressAnalytics = ({
  isCheckedHomeAndMailingAddress,
  isHomeScreenType,
  pathname,
}: ChangeAddressAnalyticsProps) => {
  const isFromProfilePage = pathname.includes('/myvaro/personal-details/');

  const logMailingAddressCheckboxChange = () => {
    const eventName = !isCheckedHomeAndMailingAddress
      ? 'Mailing address different - Checked'
      : 'Mailing address different - Unchecked';
    void logEvent(eventName, {
      category: 'profile_settings',
      source_name: 'change_home_address',
    });
  };

  const logAddressSubmit = () => {
    if (isHomeScreenType && isFromProfilePage) {
      void logEvent('Home address change submitted', {
        source_name: 'change_home_address',
        verification_type: 'profile_settings',
      });
    } else if (!isHomeScreenType && isFromProfilePage) {
      void logEvent('Mailing address change submitted', {
        source_name: 'change_home_address',
        verification_type: 'profile_settings',
      });
    }
  };

  return {
    logMailingAddressCheckboxChange,
    logAddressSubmit,
  };
};
